import { useQuery, useMutation, skipToken } from "@tanstack/react-query"
import { orderKeys, alternateOfferKeys } from "@apis/orders/queryKeys"
import {
  getFailedOrders,
  getOrderDetail,
  getAlternateOffers,
  saveOrder,
  createOrder,
  getOrderConfirmation,
  updateOrderStatus,
} from "@apis/orders/orders"

export const useGetFailedOrdersQuery = () => {
  return useQuery({
    queryKey: orderKeys.failed(),
    queryFn: getFailedOrders,
  })
}

export const useGetOrderDetailQuery = (order_id: number | undefined) => {
  return useQuery({
    queryKey: orderKeys.detail(order_id),
    queryFn: order_id ? () => getOrderDetail(order_id) : skipToken,
  })
}

export const useGetAlternateOffersQuery = (order_id: number) => {
  return useQuery({
    queryKey: alternateOfferKeys.detail(order_id),
    queryFn: () => getAlternateOffers(order_id),
  })
}

export const useSaveOrderMutation = () => {
  return useMutation({
    mutationFn: saveOrder,
  })
}

export const useCreateOrder = () => {
  return useMutation({
    mutationFn: createOrder,
  })
}

export const useGetOrderConfirmationQuery = (order_id: number | undefined) => {
  return useQuery({
    queryKey: orderKeys.confirmation(order_id),
    queryFn: order_id ? () => getOrderConfirmation(order_id) : skipToken,
  })
}

export const useUpdateOrderStatus = () => {
  return useMutation({
    mutationFn: updateOrderStatus,
  })
}
